import type { ILinkCandidateType } from './ILinkCandidateType';

/**
 * Які типи читати для «Знайдіть елемент для зв’язку» (прототип: записи всіх модулів у порядку ws.modules, перші `limit`): вибраний чип —
 * лише його тип; без пошуку — перші типи, доки разом записів (каталог) не більше, ніж треба на `limit` рядків після `excluded` виключених;
 * з пошуком — типи зі збігами (`hits`: тип → кількість) у тому ж порядку, доки збігів не вистачить на `limit`. Чиста функція.
 */
export function linkCandidatePlan(
  types: readonly ILinkCandidateType[], filter: string, limit: number, excluded: number, hits?: ReadonlyMap<string, number>,
): string[] {
  if (filter) return types.some((t) => t.rt === filter) ? [filter] : [];
  const out: string[] = [];
  let sum = 0;
  for (const t of types) {
    const n = hits ? hits.get(t.rt) ?? 0 : t.count;
    if (n <= 0) continue;
    out.push(t.rt);
    sum += n;
    if (sum >= limit + excluded) break;
  }
  return out;
}
